var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "h3",
      {
        staticClass: "title current",
        attrs: { id: "wizard2-h-0", tabindex: "-1" },
      },
      [_vm._v(_vm._s(_vm.step.title))]
    ),
    _vm._v(" "),
    _vm.step && _vm.step.subtitle && _vm.step.subtitle != ""
      ? _c("div", [_vm._v("\n  " + _vm._s(_vm.step.subtitle) + "\n")])
      : _vm._e(),
    _vm._v(" "),
    _vm.step && _vm.step.alert && _vm.step.alert != ""
      ? _c("div", [_vm._v("\n  " + _vm._s(_vm.step.alert) + "\n")])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }